import React from "react";
import { IonContent, IonPage, IonImg } from "@ionic/react";
import "./About.css";

const About: React.FC = () => {
  return (
    <IonPage>
      <IonContent>
        <div className="about-outer">
          <div className="about-inner">
            <IonImg
              className="about-image"
              src={require("../assets/images/SnappyXO_logo.png")}
            />
            <div className="about-textarea">
              <p>
                SnappyXO Projects is a companion app for SnappyXO STEM/Robotics
                Kit being manufactured and sold by Mechanismic Inc. This app
                shows a step-by-step graphical description of how to assemble
                various SnappyXO design and robot projects.
              </p>
              <h5>About Mechanismic Inc.:</h5>
              <p>
                Mechanismic Inc. is a National Science Foundation funded
                company, which is designing and manufacturing an innovative DIY
                Robotics Education and Play product for K-12 schools,
                post-secondary institutions, students, makers and hobbyists, and
                for industrial prototyping. Our products are also being sold to
                the informal STEM learning places, such as museums, libraries,
                STEM programs and camps, hackathons, and robotics competitions.
              </p>
              <h6>Contact us: info@mechanismic.com</h6>
              <a
                className="about-link"
                href="http://www.snappyxo.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.snappyxo.com
              </a>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default React.memo(About);
